const config = {
    API_URL: 'https://freelancer.test.payflow.ch/api/',
};

export default config;